import PropTypes from 'prop-types';
import { QueryClientProvider } from '@tanstack/react-query';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import ThemeProvider from '../../theme';
import { queryClient } from '../../lib/queryClient';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export default function AppProviders({ children }) {
  return (
    <Elements stripe={stripePromise}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>{children}</ThemeProvider>
      </QueryClientProvider>
    </Elements>
  );
}

AppProviders.propTypes = {
  children: PropTypes.node.isRequired,
};
